import { useContext, useEffect, useState } from 'react';
import { Button, Icon }                    from 'semantic-ui-react';
import AppContext                          from '../../../context/HeaderContext';
import BasicPaginatedTable                 from '../../../components/table/BasicPaginatedTable';
import CenterCell                          from '../../../components/table/CenterCell';
import Loading                             from '../../../components/Loading';
import { getAPI }                          from '../../../libs/fetchAPI';

function FlakyTests() {
	const { current_project_id }        = useContext(AppContext);
	const [ results, setResults ]       = useState(false);
	const [ latestVersion, setLatestVersion ] = useState(null);

	useEffect(() => {
		getAPI(`/reports/flaky_tests?project_id=${current_project_id}`).then((response) => {
			setResults(response.data);
			setLatestVersion(response.latest_version);
		});
	}, [current_project_id, setResults]);

	const columns = [
		{
			Header   : `Spec File`,
			accessor : `spec_file`,
		},
		{
			Header   : `Occurrences`,
			accessor : `flaky_count`,
		},
		{
			Header   : `Total Runs`,
			accessor : `total_runs`,
		},
		{
			Header   : `Flaky %`,
			accessor : `flaky_percent`,
			Cell     : ({ cell }) => <span>{cell.value}%</span>
		},
		{
			Header         : ``,
			accessor       : `filepath`,
			collapse       : true,
			disableFilters : true,
			Cell           : ({ cell }) => {
				const row    = cell.row.values;
				const params = {
					spec_file  : row.spec_file,
					version    : latestVersion,
					project_id : current_project_id
				};

				const link = `${window.location.origin}/specs/single?${new URLSearchParams(params)}`;

				return (
					<CenterCell>
						<a href={link} target="_blank" rel="noreferrer">
							<Button primary>
								<span>History</span>
								<span>&nbsp;&nbsp;<Icon name="external" /></span>
							</Button>
						</a>
					</CenterCell>
				);
			}
		}
	];

	if(!results) {
		return <Loading />
	}

	return (
		<>
			<BasicPaginatedTable
				columns={columns}
				data={results}
				default_page_size="25"
			/>
		</>
	)
}

export default FlakyTests;
